import { c as _c } from "react/compiler-runtime";
import type { ProfileActivityLogType } from "@/types/enums";
import ProfileActivityLogsFilterListItem from "./ProfileActivityLogsFilterListItem";
export default function UserPageIdentityActivityLogFilterList(t0) {
  const $ = _c(9);
  const {
    selected,
    options,
    setSelected
  } = t0;
  let t1;
  if ($[0] !== options || $[1] !== selected || $[2] !== setSelected) {
    let t2;
    if ($[4] !== selected || $[5] !== setSelected) {
      t2 = itemType => <ProfileActivityLogsFilterListItem key={itemType} itemType={itemType} selectedItems={selected} setSelected={setSelected} />;
      $[4] = selected;
      $[5] = setSelected;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    t1 = options.map(t2);
    $[0] = options;
    $[1] = selected;
    $[2] = setSelected;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[7] !== t1) {
    t2 = <div className="tw-absolute tw-right-0 tw-mt-1 tw-min-w-[16rem] tw-w-full tw-origin-top-right tw-rounded-lg tw-bg-iron-800 tw-shadow-xl tw-ring-1 tw-ring-black tw-ring-opacity-5"><ul className="tw-absolute tw-z-10 tw-mt-1 tw-max-h-[calc(20rem+_-10svh)] tw-w-full tw-list-none tw-overflow-x-hidden tw-overflow-y-auto tw-scrollbar-thin tw-scrollbar-track-iron-800 tw-scrollbar-thumb-iron-500 desktop-hover:hover:tw-scrollbar-thumb-iron-300 tw-rounded-lg tw-bg-iron-800 tw-py-2 tw-pl-1.5 tw-pr-1.5 tw-text-base tw-shadow-xl tw-ring-1 tw-ring-inset tw-ring-white/10 focus:tw-outline-none sm:tw-text-sm">{t1}</ul></div>;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}